export default __webpack_public_path__ + "static/media/branding_icon_enreach.519de4e7.png";